module.exports = "//static.hsappstatic.net/salesImages/static-1.403/logos/outlook.jpg"